export const routes = {
  LOGIN: "/",
  HOME: "/home",
  USER_PROFILE: "/user-profile",
  CONTACT_US: "/contact-us",
  SERVICES: "/services",
  LISTING_PAGE: "/home/list-of-funeral-homes",
  DETAILS_PAGE: "/home/list-of-funeral-homes/details/:id",
  REVIEWS_PAGE: "/home/list-of-funeral-homes/details/:id/reviews",
  PRENEED_PLANNERS_PAGE: "/home/list-of-funeral-homes/preneed-planners",
  PRENEED_PLANNERS_DETAILS_PAGE:
    "/home/list-of-funeral-homes/preneed-planners/:id",
  ORDER_SUMMARY_PAGE: "/order-summary",
  PAYMENT_PAGE: "/order-summary/payment",
  CART_PAGE: "/cart",
  PAYMENT_STATUS_PAGE: "/payment-status",
  BECOME_PROVIDER: "/become-provider",
  BECOME_PARTNER: "/become-provider/partner-registration",
  PARTNER: "/become-provider",
  NO_ROLE: "/no-role",
  DASHBOARD: "/home/dashboard",
  EMAILVERIFICATION: "/verify-email",
  RESETPASSWORD: "/reset-password/",
  FORGOTPASSWORD: "/forgot-password",
  CHANGEPASSWORD: "/home/change-password",
  AUTH_CALLBACK: "/auth/callback",
  ORDER_HISTORY_PAGE: "/order-history",
  ORDER_DETAILS_PAGE: "/order-history/:id",

  //Partner-management
  REQUESTS: "/home/partner-management/requests",
  PARTNERLIST: "/home/partner-management/partner-list",
  CREATE_PLAN: "/home/partner-management/create-plan",
  PARTNERDETAILS: "/home/partner-management/partner-list/details",
  PARTNER_DETAILS_CHANGE_PLAN:
    "/home/partner-management/partner-list/details/change-plan",

  // Lead-management
  LEADLIST: "/home/lead-management/lead-details",
  CREATELEAD: "/home/lead-management/lead-details/create-lead",
  SOCIALIMPORTLEAD: "/home/lead-management/lead-details/social-import-lead",

  // Campaigns
  CREATECAMPAIGN: "/home/campaigns/create-campaign",
  CAMPAIGNLIST: "/home/campaigns/campaign-list",

  // Footer-navigations

  //Settings
  PERSONAL_SETTINGS: "/home/settings/personal-settings",
  PROFILE: "/home/settings/personal-settings/profile",

  //Myplans
  MY_PLANS: "/home/settings/myplans",
  USER_CHANGE_PLAN: "/home/settings/myplans/change-plan",

  COMPANY_PROFILE: "/home/settings/company-settings/profile",
  COMPANYSETTINGS: "/home/settings/company-settings",

  TERMSOFSERVICES: "/home/terms-of-services",
  TERMS_OF_SERVICE: "/terms-of-service",
  NOTIFICATIONS: "/home/notifications",

  // User Management
  USER_MANAGEMENT_LIST: "/home/user-management/user-management-list",
  USER_MANAGEMENT_ROLE: "/home/user-management/user-management-role",

  //admin management
  ADMIN_LOGIN: "/admin/login",
  ADMIN_MANAGEMENT: "/admin/admin-dashboard",
  ADMIN_TERMS_OF_SERVICE: "/admin/terms-of-service",
  ADMIN_ORDER_MANAGEMENT: "/admin/order-management",
  ADMIN_VIEW_ORDER: "/admin/order-management/:id",

  // Provider Request Management
  PROVIDER_MANAGEMENT: "/admin/provider-management",
  PROVIDER_REQUESTS: "/admin/provider-management/provider-requests",
  PROVIDER_REQUEST_DETAILS: "/admin/provider-management/provider-requests/:id",
  PROVIDER_PROFILES: "/admin/provider-management/provider-profiles",
  PROVIDER_PROFILE_DETAILS: "/admin/provider-management/provider-profiles/:id",

  // Planner Management
  PLANNER_MANAGEMENT: "/admin/planner-management",
  PLANNER_REQUESTS: "/admin/planner-management/planner-requests",
  PLANNER_REQUEST_DETAILS: "/admin/planner-management/planner-requests/:id",
  PLANNER_PROFILES: "/admin/planner-management/planner-profiles",
  PLANNER_PROFILE_DETAILS: "/admin/planner-management/planner-profiles/:id",
  //Service Management
  SERVICE_LIST: "/admin/service-management/service-list",
  ADMIN_PROFILE_MANAGEMENT: "/admin/profile-management",
  ADMIN_USER_MANAGEMENT: "/admin/user-management",
  //Communication Management
  ADMIN_COMMUNICATION_MANAGEMENT: "/admin/communication-management",
  ADMIN_COMMUNICATION_TICKET_DETAILS: "/admin/communication-management/:id",

  //provider management
  PROVIDER_LOGIN: "/provider/login",
  PROVIDER_PROFILE_MGMT: "/provider/profile-mgmt",
  PROVIDER_SERVICE_LIST: "/provider/service-management/service-list",
  PROVIDER_DASHBOARD: "/provider/provider-dashboard",
  PROVIDER_FORGOT_PWD: "/provider/forgot-password",
  PROVIDER_RESET_PWD_EMAIL_LINK: "/provider/reset-password",
  PROVIDER_PROFILE: "/provider/profile",
  PROVIDER_CONTRACT_MANAGEMENT: "/provider/contract-management",
  BOOKING_AND_APPOINTMENT: "/provider/contract-orders",
  PROVIDER_LEADS: "/provider/leads",
  PROVIDER_LEAD_DETAILS: "/provider/leads/:id",
  PAYMENTS_AND_BILLING: "/provider/payments-and-billing",
  PAYMENT_BILLING_VIEW: "/provider/payments-and-billing/:id",

  PROVIDER_COMMUNICATION: "/provider/communication",
  PROVIDER_COMMUNICATION_TICKET_DETAILS: "/provider/communication/:id",
  PROVIDER_TERMS_OF_SERVICE: "/provider/terms-of-service",

  //preneed management
  PRENEED_LOGIN: "/preneed/login",
  PRENEED_DASHBOARD: "/preneed/preneed-dashboard",
  PRENEED_PROFILE_MGMT: "/preneed/profile-mgmt",
  PRENEED_TERMS_OF_SERVICE: "/preneed/terms-of-service",
  PRENEED_CONTRACT_MANAGEMENT: "/preneed/contract-management",
  PRENEED_PAYMENTS_AND_BILLING: "/preneed/payments-and-billing",
  PRENEED_PAYMENT_BILLING_VIEW: "/preneed/payments-and-billing/:id",
  PRENEED_BOOKING_AND_APPOINTMENT: "/preneed/contract-orders",
  PRENEED_LEADS: "/preneed/leads",
  PRENEED_LEAD_DETAILS: "/preneed/leads/:id",
  PRENEED_COMMUNICATION: "/preneed/communication",
  PRENEED_COMMUNICATION_TICKET_DETAILS: "/preneed/communication/:id",
  PRENEED_PROFILE: "/preneed/profile",
  PRENEED_SERVICE_PACKAGE: "/preneed/service-package",
  PRENEED_FORGOT_PWD: "/preneed/forgot-password",
  PRENEED_RESET_PWD_EMAIL_LINK: "/preneed/reset-password",
};
